/**
 * Labstep
 *
 * @module components/User/Signin/SocialMedia
 * @desc Social Media Buttons for login/register
 */

import { Google as GoogleLogin } from 'labstep-web/components/User/Signin/SocialMedia/Google';
import { UserRegisterSocialMediaContainer } from 'labstep-web/containers/User/Register/SocialMedia';
import type React from 'react';
import type {
  ISocialMediaProps,
  UserSigninSocialMediaProps,
} from './types';

const SocialMedia: React.FC<ISocialMediaProps> = ({
  loginGoogle,
  mode,
  body,
  options,
}) => (
  <GoogleLogin
    loginGoogle={loginGoogle}
    text={mode === 'signup' ? 'signup_with' : 'signin_with'}
    body={body}
    options={options}
  />
);

export const UserSigninSocialMedia: React.FC<
  UserSigninSocialMediaProps
> = (props) => (
  <UserRegisterSocialMediaContainer>
    {({ loginGoogle }) => (
      <SocialMedia loginGoogle={loginGoogle} {...props} />
    )}
  </UserRegisterSocialMediaContainer>
);
